// Handle local storage array retrieval
/*
(function() {
  function getWishlist() {
    return JSON.parse(localStorage.getItem('wishlist')) || [];
  }

  function saveWishlist(items) {
    localStorage.setItem('wishlist', JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('wishlist:updated'));
  }

  function updateWishlistButtons() {
    const wishlist = getWishlist();

    document.querySelectorAll('.wishlist-btn').forEach((button) => {
      const handle = button.dataset.productHandle;
      const text = button.querySelector('.wishlist-text');

      if (wishlist.includes(handle)) {
        button.classList.add('is-active');
        if (text) text.innerHTML = '♥ Added';
      } else {
        button.classList.remove('is-active');
        if (text) text.innerHTML = '♡ Add to Wishlist';
      }
    });
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.wishlist-btn');
    if (!btn) return;

    e.preventDefault();

    let wishlist = getWishlist();
    const handle = btn.dataset.productHandle;

    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(item => item !== handle);
    } else {
      wishlist.push(handle);
    }

    saveWishlist(wishlist);
    updateWishlistButtons();
  });

  document.addEventListener('DOMContentLoaded', updateWishlistButtons);
})();

*/

(function() {
  function getWishlist() {
    return JSON.parse(localStorage.getItem('wishlist')) || [];
  }

  function saveWishlist(items) {
    localStorage.setItem('wishlist', JSON.stringify(items));
  }

  function updateWishlistButtons() {
    const wishlist = getWishlist();

    document.querySelectorAll('.wishlist-btn').forEach((button) => {
      const handle = button.dataset.productHandle;
      const text = button.querySelector('.wishlist-text');

      if (wishlist.includes(handle)) {
        button.classList.add('active');
        button.classList.add('is-active');

        if (text) {
          text.innerHTML = '♥ Added';
        } else {
          button.innerHTML = '♥';
        }
      } else {
        button.classList.remove('active');
        button.classList.remove('is-active');

        if (text) {
          text.innerHTML = '♡ Add to Wishlist';
        } else {
          button.innerHTML = '♡';
        }
      }
    });
  }

  // Event delegation (works after AJAX reload)
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.wishlist-btn');
    if (!btn) return;

    e.preventDefault();

    let wishlist = getWishlist();
    const handle = btn.dataset.productHandle;

    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(item => item !== handle);
    } else {
      wishlist.push(handle);
    }

    saveWishlist(wishlist);
    updateWishlistButtons();
  });

  document.addEventListener('DOMContentLoaded', updateWishlistButtons);

  // Motion theme dynamic section refresh
  document.addEventListener('shopify:section:load', updateWishlistButtons);
  document.addEventListener('theme:reinit', updateWishlistButtons);
})();